export function applicationPath(p) {
  return `/#/round/${p.chainId}/${p.roundId.toLowerCase()}/${p.applicationId}`;
}
export function collectionPath(collectionCid) {
  return `/#/collections/${collectionCid}`;
}
export function projectPath(p) {
  return `/#/projects/${p.projectId}`;
}